<button class="quickview__close" type="button" appClick (click)="close()" *ngIf="props">
    <app-icon name="cross-20" size="20"></app-icon>
</button>

<div class="fields-container" *ngIf="!props">
    <div class="row">
        <div class="col-6">
            <div class="draggable-item" draggable="true" (dragstart)="onDragStart($event, 'my-tidy-section')" (dragend)="onDragEnd($event)">
                <div class="img-container">
                    <img width="100%" height="100%" src="/assets/images/custom/draggable/draggable_section.png">
                </div>
                Sezione
            </div>
        </div>
        <div class="col-6">
            <div class="draggable-item" draggable="true" (dragstart)="onDragStart($event, 'my-tidy-carousel')" (dragend)="onDragEnd($event)">
                <div class="img-container">
                    <img width="100%" height="100%" src="/assets/images/custom/draggable/draggable_carousel.png">
                </div>
                Carousel
            </div>
        </div>
    </div>
</div>

<div class="fields-container" *ngIf="props">
    <nav>
        <div class="nav nav-tabs" role="tablist">
            <a (click)="changeTab(1)" class="nav-link cursor-pointer" [ngClass]="{'active': activeTab == 1}" data-toggle="tab"
                role="tab">Basic</a>
            <a (click)="changeTab(2)" class="nav-link cursor-pointer" [ngClass]="{'active': activeTab == 2}" data-toggle="tab"
                role="tab">Advanced</a>
        </div>
    </nav>
    <div class="tab-content">
        <div class="tab-pane fade" [ngClass]="{'show active': activeTab == 1}" role="tabpanel">
            <div [formGroup]="props.form">
                <div class="row mb-1" *ngFor="let propKey of props.keys" [attr.hidden]="props.isHidden(propKey) ? true : null">
                    <div class="col-12" *ngIf="props.getProps(propKey).constructor.name != 'MyTidyBooleanC'">
                        {{props.getProps(propKey).label}}
                    </div>
                    <div class="col-12">
                        <ng-container [ngSwitch]="props.getProps(propKey).constructor.name">
                            <ng-container *ngSwitchCase="'MyTidySelectC'">
                                <ng-container [ngSwitch]="propKey">
                                    <select *ngSwitchCase="'defaultGroup'" [formControl]="props.form.controls[propKey]" type="text" class="form-control">
                                        <option [ngValue]="option.codicefamiglia" *ngFor="let option of props.getOptionsOf(propKey)">{{option.descrizione}}</option>
                                    </select>
                                    <select *ngSwitchDefault [formControl]="props.form.controls[propKey]" type="text" class="form-control">
                                        <option [ngValue]="option.value" *ngFor="let option of props.getOptionsOf(propKey)">{{option.description}}</option>
                                    </select>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngSwitchCase="'MyTidyBooleanC'">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input [formControl]="props.form.controls[propKey]" type="checkbox" class="form-check-input">
                                        {{props.getProps(propKey).label}}
                                    </label>
                                </div>
                            </ng-container>

                            <ng-container *ngSwitchCase="'MyTidyArrayC'">
                                <ng-select *ngIf="propKey == 'groups'" [formControl]="props.form.controls[propKey]"
                                placeholder="Tutti prodotti"
                                [multiple]="true" bindLabel="descrizione" [items]="getItems(propKey)"></ng-select>
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                <input [formControl]="props.form.controls[propKey]" type="text" class="form-control"
                                    placeholder="{{props.getProps(propKey).label}}">
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{'show active': activeTab == 2}" role="tabpanel">
            <div class="row mb-1" *ngFor="let styleGroup of styles">
                <div class="col-12">
                    <b>{{styleGroup.caption}}</b>
                    <div *ngFor="let style of styleGroup.styles" [formGroup]="style.form">
                        <span>{{style.title}}</span>
                        <ng-container [ngSwitch]="style.className">
                            <ng-container *ngSwitchCase="'MyTidyStyleSelectC'">
                                <select formControlName="value" class="form-control">
                                    <option [ngValue]="option" *ngFor="let option of style.styleArray">
                                        {{option}}
                                    </option>
                                </select>
                            </ng-container>

                            <ng-container *ngSwitchCase="'MyTidyStyleDimensionC'">
                                <div style="display: flex; flex-wrap: nowrap;">
                                    <input formControlName="left" class="form-control" placeholder="L">
                                    <input formControlName="top" class="form-control" placeholder="T">
                                    <input formControlName="right" class="form-control" placeholder="R">
                                    <input formControlName="bottom" class="form-control" placeholder="B">
                                    <select formControlName="um" class="form-control">
                                        <option [ngValue]="dim" *ngFor="let dim of style.dimensionArray">{{dim}}</option>
                                    </select>
                                </div>
                            </ng-container>

                            <ng-container *ngSwitchCase="'MyTidyStyleColor'">
                                <div style="display: flex; flex-wrap: nowrap;">
                                    <input formControlName="value" class="form-control" type="color">
                                </div>
                            </ng-container>

                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div style="position: absolute; text-align: center; bottom: 10px; left: 0; right: 0;">
    <button *ngIf="props" class="btn btn-danger" (click)="remove()"><i class="fas fa-trash"></i>
        Elimina</button>&nbsp;
    <button class="btn btn-success" (click)="saveChanges()"><i class="fas fa-save"></i>
        Salva</button>
</div>
